import { motion, AnimatePresence } from "framer-motion";

export default function QPointsModal({
  open,
  onClose,
  configs,
  onChange,
  onSave,
}) {
  if (!open) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white w-full max-w-md rounded-2xl p-6 shadow-xl"
          initial={{ scale: 0.9, y: 20 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.9, y: 20 }}
        >
          <h3 className="text-xl font-bold text-gray-800 mb-4">
            Configuración QPUNTOS
          </h3>

          <div className="space-y-4">
            {configs.map((c) => (
              <div
                key={c.id ?? c._id}
                className="flex items-center justify-between gap-4"
              >
                <span className="capitalize text-gray-700 font-medium">
                  {c.action === "register"     && "Registro"}
                  {c.action === "purchase"     && "Compra"}
                  {c.action === "referral"     && "Referido"}
                  {c.action === "review"       && "Reseña aprobada"}
                  {c.action === "phone_verify" && "Verificar WhatsApp"}
                </span>

                <input
                  type="number"
                  value={c.points}
                  min={0}
                  onChange={(e) => onChange(c.id ?? c._id, Number(e.target.value))}
                  className="border rounded-lg px-3 py-1 w-24 text-center"
                />
              </div>
            ))}
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-xl bg-gray-100 hover:bg-gray-200"
            >
              Cancelar
            </button>
            <button
              onClick={onSave}
              className="px-4 py-2 rounded-xl bg-supernova-500 text-white hover:bg-supernova-600"
            >
              Guardar cambios
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
